export const normalizeString = (str: string): string => {
    if (!str) return '';
    return str
        .normalize('NFD') // Decompose accents
        .replace(/[\u0300-\u036f]/g, '') // Remove accents
        .replace(/[^a-zA-Z0-9\s]/g, ' ') // Replace special chars with space
        .replace(/\s+/g, ' ') // Collapse multiple spaces
        .trim()
        .toLowerCase();
};

export const getBigrams = (str: string): Set<string> => {
    const bigrams = new Set<string>();
    for (let i = 0; i < str.length - 1; i++) {
        bigrams.add(str.substring(i, i + 2));
    }
    return bigrams;
};

// Sørensen-Dice coefficient
export const calculateSimilarity = (str1: string, str2: string): number => {
    const norm1 = normalizeString(str1);
    const norm2 = normalizeString(str2);

    if (norm1 === norm2) return 1;
    if (norm1.length < 2 || norm2.length < 2) return 0;

    const bg1 = getBigrams(norm1);
    const bg2 = getBigrams(norm2);

    let intersectionSize = 0;
    for (const bg of bg1) {
        if (bg2.has(bg)) intersectionSize++;
    }

    return (2.0 * intersectionSize) / (bg1.size + bg2.size);
};

export interface MatchResult {
    bestMatch: string | null;
    score: number;
}

export const findBestMatch = (target: string, list: string[], threshold: number = 0.75): MatchResult => {
    let bestMatch: string | null = null;
    let highestScore = 0;

    for (const item of list) {
        const score = calculateSimilarity(target, item);
        if (score > highestScore) {
            highestScore = score;
            bestMatch = item;
        }
    }

    if (highestScore >= threshold) {
        return { bestMatch, score: highestScore };
    }

    return { bestMatch: null, score: highestScore };
};
